import css from '@styled-system/css';
import styled from 'styled-components';
import theme from '../theme';
import { alignSelf, border, compose, color, flexbox, layout, position, shadow, space } from 'styled-system';
/**
 * With Panel, you can display a div relative to the boundaries of the Map.
 * It is similiar to Asimov's `Box` component but is focused on overlaying on a map.
 *
 * To set where to position `Panel` relative to the Map, use `top`, `bottom`, `left`, and/or `right` property.
 */
const Panel = styled.div `
  ${css({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'body',
    fontWeight: 'light',
    lineHeight: 'normal',
    position: 'absolute',
    padding: '10px'
})}
  ${compose(alignSelf, border, color, flexbox, layout, shadow, space, position)}
`;
Panel.defaultProps = { theme };
export default Panel;
//# sourceMappingURL=Panel.js.map